import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ConsentBanner from "./components/ConsentBanner";
import HomePage from "./pages/HomePage";
import WorkshopPage from "./pages/WorkshopPage";
import ContactPage from "./pages/ContactPage";
import AboutPage from "./pages/AboutPage";
import NewsletterPage from "./pages/NewsletterPage";
import YoutubePage from "./pages/YoutubePage";
import { trackPageView } from "./lib/analytics";
import AiCareerAdvantagePage from "./pages/AiCareerAdvantagePage";
import AiCareerAdvantageThankYouPage from "./pages/AiCareerAdvantageThankYouPage";

function ScrollManager() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      return;
    }

    const targetId = location.hash.slice(1);

    const scrollToTarget = () => {
      const element = document.getElementById(targetId);

      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };

    const frameId = window.requestAnimationFrame(scrollToTarget);

    return () => window.cancelAnimationFrame(frameId);
  }, [location.pathname, location.hash]);

  return null;
}

function AnalyticsManager() {
  const location = useLocation();

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    const timeoutId = window.setTimeout(() => {
      trackPageView(path);
    }, 0);

    return () => window.clearTimeout(timeoutId);
  }, [location.pathname, location.search]);

  return null;
}

export function AppFrame() {
  return (
    <>
      <ScrollManager />
      <AnalyticsManager />
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/newsletter" element={<NewsletterPage />} />
          <Route path="/youtube" element={<YoutubePage />} />
          <Route path="/workshops" element={<WorkshopPage />} />
          <Route path="/ai-career-advantage" element={<AiCareerAdvantagePage />} />
          <Route path="/ai-career-advantage/thank-you" element={<AiCareerAdvantageThankYouPage />} />
          <Route path="/workshop" element={<Navigate to="/workshops" replace />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </main>
      <Footer />
      <ConsentBanner />
    </>
  );
}

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <BrowserRouter>
        <AppFrame />
      </BrowserRouter>
    </div>
  );
}

export default App;
